<div class="ms-3 me-3 invitation-container">
  <!-- <div *ngIf="isLoading" class="loading">Loading invitation...</div> -->
  <div *ngIf="isLoading" class="loading-container">
    <mat-progress-spinner diameter="50" mode="indeterminate"></mat-progress-spinner>
    <p class="mt-3">Caricando l'invito...</p>
  </div>

  <div *ngIf="error" class="error">
    {{ error }}
  </div>

  <div *ngIf="invitation !== null" class="invitation-details">
    <div class="text-center">

      <h2 class="mb-3 d-flex align-items-center justify-content-center gap-2">
        <!-- <mat-icon class="big-icon">handshake</mat-icon> -->
        Invito ricevuto!
      </h2>
      <img mat-card-image class="col-md-2 col-9 mb-3" src="izy_image_4.png" alt="Home image">
      <p>
        Sei stato invitato a ad accedere all'account
        <strong>{{ invitation.organization_name }}</strong>.
      </p>
      <p class="text-muted">Email: {{ invitation.email }}</p>
      <p>Stato richiesta: 
        <mat-chip class="ms-1">{{ getTranslatedStatus(invitation.status || '') }}</mat-chip>
      </p>

      <div *ngIf="invitation.status !== 'PENDING'">
        <p>Questo invito è stato già {{ getTranslatedStatus(invitation.status || '') | lowercase }}.</p>
      </div>

      <div *ngIf="invitation.status !== 'PENDING'" class="mb-3 d-flex flex-row justify-content-center gap-3 mx-md-5 mx-2">
        <button
          matButton="filled"
          color="primary"
          (click)="navigateToHome()"
        >
        <mat-icon>login</mat-icon>
          Entra
        </button>
      </div>

      <ng-container *ngIf="user === null">
        <p>Per favore, fai login con la tua mail per accettare l'invito.</p>
        <a
          mat-raised-button
          matTooltip="Login with the correct email to accept invitation"
          color="primary"
          [disabled]="isLoading || user !== null"
          [routerLink]="['/', 'auth', 'login']"
          [queryParams]="{ next: '/accept-invitation/' + uuid }"
          queryParamsHandling="merge"
        >
        <mat-icon>login</mat-icon>
          Login
        </a>
        <div
          class="hint-error"
          *ngIf="user !== null && user?.email !== invitation?.email"
        >
          Devi fare login come {{ invitation.email }}!
        </div>
      </ng-container>

      <ng-container *ngIf="user !== null">
        <div *ngIf="user?.email !== invitation?.email">
          <a
            class="mb-2"
            mat-raised-button
            color="primary"
            [disabled]="isLoading"
            [routerLink]="['/', 'auth', 'logout']"
            [queryParams]="{
              next: '/accept-invitation/' + uuid,
              'next-after-login': 1
            }"
            queryParamsHandling="merge"
          >
          <mat-icon>account_circle</mat-icon>
            Cambia utente
          </a>
        </div>

        <div
          class="mb-3 d-flex flex-row justify-content-center gap-3 mx-md-5 mx-2"
          *ngIf="
            invitation.status === 'PENDING' && user?.email === invitation?.email
          "
        >
          <div>
            <button
              matButton="outlined"
              color="warn"
              (click)="declineInvitation()"
            >
            <mat-icon>close</mat-icon>
              Rifiuta invito
            </button>
          </div>
          <div>
            <button
              matButton="filled"
              color="primary"
              (click)="acceptInvitation()"
            >
            <mat-icon>check</mat-icon>
              Accetta invito
            </button>
          </div>
        </div>
        <div class="mt-2 hint">Attualmente, stai effettuando il login come {{ user.email }}.</div>
      </ng-container>
    </div>
  </div>
  <div style="overflow-x: auto" class="mt-5 p-1 d-none">
    <div class="border">{{ invitation | json }}</div>
    <div class="border">{{ error | json }}</div>
    <div class="border">{{ isLoading | json }}</div>
    <div class="border">{{ user | json }}</div>
  </div>
</div>
